import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-fade";

// import required modules
import { EffectFade, Autoplay } from "swiper/modules";

import Img1 from "./assets/images/bg_1.webp";
import Img2 from "./assets/images/bg_2.webp";
import Img3 from "./assets/images/bg_3.webp";

import Img1m from "./assets/images/orange_terra.jpg";
import Img2m from "./assets/images/Fraise_terra.jpg";
import Img3m from "./assets/images/Citron_terra_3.jpg";

const Carousel = () => {
  return (
    <div id="home" className="mt-0 relative">
      {/* Overlay div that covers the entire carousel */}
      <div className="absolute top-20 md:top-0 left-0 w-full h-full z-10 flex pt-16 md:pt-0 md:items-center justify-center md:justify-start  md:pl-14 pointer-events-none">
        <div className="flex-col  text-5xl md:text-7xl text-gray-700">
          <h1>
            <span className="text-[#6BA368]">N</span>aturel
          </h1>
          <h1>
            <span className="text-[#A3C1DA]">F</span>rais
          </h1>
          <h1>
            de <span className="text-[#4A4A48]">Q</span>ualité
          </h1>
        </div>
      </div>
      <Swiper
        spaceBetween={30}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        effect={"fade"}
        speed={2000}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        modules={[EffectFade, Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
          <picture>
            {/* Image pour les écrans mobiles */}
            <source srcSet={Img1m} media="(max-width: 768px)" />
            {/* Image par défaut pour les écrans larges */}
            <img
              src={Img1} // Fallback pour les navigateurs qui ne supportent pas <source>
              alt="1"
              className="w-full h-screen object-cover"
            />
          </picture>
        </SwiperSlide>
        <SwiperSlide>
          <picture>
            {/* Image pour les écrans mobiles */}
            <source srcSet={Img2m} media="(max-width: 768px)" />
            {/* Image par défaut pour les écrans larges */}
            <img
              src={Img2} // Fallback pour les navigateurs qui ne supportent pas <source>
              alt="2"
              className="w-full h-screen object-cover"
            />
          </picture>
        </SwiperSlide>
        <SwiperSlide>
          <picture>
            {/* Image pour les écrans mobiles */}
            <source srcSet={Img3m} media="(max-width: 768px)" />
            {/* Image par défaut pour les écrans larges */}
            <img
              src={Img3} // Fallback pour les navigateurs qui ne supportent pas <source>
              alt="3"
              className="w-full h-screen object-cover"
            />
          </picture>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Carousel;